import { processFilters} from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

export type Props = ApiMethodBase & { importedFilters, discovery_rule_id}

export const  processDiscoveryRule  = ({ importedFilters, discovery_rule_id , eventEmitter,}: Props) => {
    if (importedFilters.length > 0) processFilters(importedFilters,discovery_rule_id);
    eventEmitter.emit(Event.applyFilter);
    eventEmitter.emit(Event.updateGaugeMetrics);    
};


